import { GroupState } from '@/composition/groups'
import { RouteLocationNormalizedLoadedGeneric, Router } from 'vue-router'

export function handleBackButton(
  router: Router,
  route: RouteLocationNormalizedLoadedGeneric
): void {
  if (window.history?.state?.back) {
    router.back()
  } else {
    const groupSlug =
      route.params.groupSlug ?? GroupState.state?.currentGroup?.slug
    if (groupSlug) {
      router.push({
        name: 'home',
        params: { groupSlug },
      })
    } else {
      /** redirect to base url  -> /communities/groups/ */
      router.push('/communities/groups/')
    }
  }
}

export function deleteCurrentHistoryEntry(): void {
  if (window.history.length > 1) {
    // Go back one step in history, but replace the previous state with the current URL
    const prevUrl = document.referrer || '/' // fallback if no referrer

    // Replace current entry with the previous one
    window.history.replaceState(window.history.state, '', prevUrl)

    // Now move back so the current URL is skipped
    window.history.back()
  }
}

export const bottomNavBarRouteConfig = [
  {
    name: 'Home',
    routeName: ['clientportal-home'],
  },

  {
    name: 'Communities',
    routeName: [
      'home',
      'channel-overview',
      'channel-post-view',
      'group-post-view',
      'content-unavailable',
      'group-home-search',
      'group-search-post-view',
      'channel-search',
      'channel-search-post-view',
      'learning-home',
      'group-member-list',
      'events',
      'leaderboard',
      'about',
      'private-group',
      'inactive-group',
      'no-communities-mobile',
      'global-user-profile',
    ],
  },
  {
    name: 'Courses',
    // TODO: JA: Update post Bharat's changes
    routeName: ['my-courses'],
  },
  {
    name: 'More',
    routeName: [
      'communities-more',
      'profile-container',
      'documents-and-payments',
    ],
  },
]
